import { Injectable } from '@angular/core';
import { AuthService } from '../../../auth/auth.service';
import { UserService } from '../../../operator/user-service/user.service';
import { take } from 'rxjs/operators';
import { MultiBuyerCmp } from '../../interfaces/company.interface';
import { CompanyService } from '../company/company.service';

@Injectable({
  providedIn: 'root',
})
export class MultiBuyerSession {
  constructor(
    private readonly _userService: UserService,
    private readonly _companyService: CompanyService,
    private readonly _auth: AuthService
  ) {}

  public async buyers(
    cmpId: number,
    buyerCompanyId?: number
  ): Promise<MultiBuyerCmp[]> {
    return this._companyService
      .getMultiBuyerCmpsList(cmpId, buyerCompanyId)
      .pipe(take(1))
      .toPromise();
  }

  public async selectBuyer(
    cmpId: number,
    buyerCompanyId: number
  ): Promise<MultiBuyerCmp> {
    const buyers = await this.buyers(cmpId, buyerCompanyId).catch((error) => {
      console.error('Error while find buyers list for multi buyer: ', error);
    });

    if (!buyers || buyers.length === 0) {
      throw new Error('No buyer company found for the provided IDs.');
    }

    const selectedCompany = buyers[0];

    const tokenResponse = await this._userService
      .getToken(selectedCompany.apiUserId, false)
      .toPromise();

    if (tokenResponse) {
      const multiBuyerCmpAuth = {
        ...tokenResponse,
        ...selectedCompany,
        parentCompany: cmpId,
      };

      this._auth.setSelectedMultiBuyerCompanyData(
        multiBuyerCmpAuth,
        selectedCompany.id
      );
    }
    return selectedCompany;
  }

  public resetBuyerToken(): void {
    this._auth.resetMultiBuyerToken();
  }
}
